import './site.js';
import { botFlowCanvas, useRouteWorker } from './bot-flow-canvas.js';
import BotFlowRouteWorker from './bot-flow-route-worker.js?worker&inline';
import { botFlowEditor, botApiVariablePicker } from './bot-flow-editor.js';
import { dashboardTour } from './dashboard-tour.js';

useRouteWorker(() => new BotFlowRouteWorker());

const registerDevelopmentComponents = () => {
    window.Alpine.data('botFlowCanvas', botFlowCanvas);
    window.Alpine.data('botFlowEditor', botFlowEditor);
    window.Alpine.data('botApiVariablePicker', botApiVariablePicker);
    window.Alpine.data('dashboardTour', dashboardTour);
};
if (window.Alpine) {
    registerDevelopmentComponents();
} else {
    document.addEventListener('alpine:init', registerDevelopmentComponents, { once: true });
}
